// extracted by mini-css-extract-plugin
export default {"button":"Zk-z","reviewSort":"_k-z"};